import { FC } from "react";

import { Cake } from "shared/assets/icons";
import { Icon, MutedDarkText } from "shared/styles";
import { colors } from "shared/styles/constants";

import { IBirthdayEvent } from "Bands/types";

import { StyledIcon, StyledCalendarItem, StyledCalendarItemText } from "./styles";
import { getMemberName } from "Bands/utils";

interface CalendarBirthdayProps {
  birthday: IBirthdayEvent;
}

export const CalendarBirthday: FC<CalendarBirthdayProps> = ({ birthday }) => {
  return (
    <>
      <StyledCalendarItem as="span">
        <StyledIcon>
          <Icon size="m" as={Cake} color={colors.grey4} />
        </StyledIcon>
        <StyledCalendarItemText>
          <span>{getMemberName(birthday)}</span>
          {!!birthday.bands?.length && <MutedDarkText>{birthday.bands.join(", ")}</MutedDarkText>}
        </StyledCalendarItemText>
      </StyledCalendarItem>
    </>
  );
};
